import React, { useEffect, useState } from 'react';
import { AreaExecutiveSummary, CrfAreaExecutiveSummary } from '..';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon } from 'antd'
import { GridView, SimpleView, storage, Widget } from '@digital/ui';
import { getPermissions } from '@app/api/account';
import { useActions } from '@digital/ui/lib/store';
const { Panel } = Collapse;

const Home = () => {
  const [permissions, setPermissions] = useState<string[]>(storage.getPermissions() || []);
  const loadPermissions = useActions((state: any) => state.permission.loadPermissions);

  useEffect(() => {
    if (permissions.length === 0) {
      getPermissions().then((response: any) => {
        if (response && response.permissoes) {
          loadPermissions(response.permissoes);
          setPermissions(response.permissoes);
        }
      }).catch((error: any) => {
        console.error('Erro ao carregar permissões:', error);
      });
    }
  }, [loadPermissions, permissions.length]);

  const hasPerm = (perms: string[]) => {
    return permissions.some(p1 => perms.some(p2 => p2 === p1));
  };

  return (
    <SimpleView>
      <GridView noform>
        {
          hasPerm(['MODULO_INVESTIMENTO_VISUALIZAR_MENU']) ?
            <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
              <Panel key="1" header="Módulo Investimento" style={{ border: 0 }}>
                <Widget >
                  <AreaExecutiveSummary
                    telaInicial={true}
                  />
                </Widget>
              </Panel>
            </Collapse>
            : <></>
        }
        {
          hasPerm(['MODULO_CONTA_RESULTADO_E_MODULO_FECHAMENTO_MINA_VISUALIZAR_MENU']) ?
            <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
              <Panel key="2" header="Módulo CR e CFM " style={{ border: 0 }}>
                <Widget >
                  <CrfAreaExecutiveSummary
                    telaInicial={true}
                  />
                </Widget>
              </Panel>
            </Collapse>
            : <></>
        }
      </GridView>
    </SimpleView>
  );
}

export default Home;

